<template>
    <div class="feature-tables">
        <div
            v-for="(featureTable, propertyName) in seperatedFeatureData"
            :key="`item_${propertyName}`"
            class="feature-table"
            :style="paperSizeStyle"
        >
            <h1>{{ featureTable.title }}</h1>
            <b-table
                :items="featureTable.data"
                :fields="featureTable.fields"
            ></b-table>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { getGroups } from '../../services/selections';

    export default {
        name: 'PrintResultTable',
        props: {
            previewConfig: { type: Object, required: true },
            mode: { type: String, required: true }
        },
        computed: {
            ...mapState(['printTableResults']),
            ...mapGetters(['getSelectionData']),
            seperatedFeatureData: function () {
                if (this.getSelectionData) {
                    return this.$_getSeperatedFeatureDataMobileNew();
                } else {
                    return this.$_getSeperatedFeatureData();
                }
            },
            paperSizeStyle: function () {
                if (this.mode === 'preview') {
                    return {
                        width: `${
                            this.previewConfig.paper.width * this.displayScale
                        }px`,
                        height: `${
                            this.previewConfig.paper.height * this.displayScale
                        }px`
                    };
                }
                return {
                    width: `${this.previewConfig.paper._props.width}mm`,
                    // -1 prevents extra page
                    'min-height': `${this.previewConfig.paper._props.height - 1}mm`,
                    overflow: 'hidden'
                };
            }
        },
        methods: {
            $_getSeperatedFeatureData() {
                if (!this.printTableResults) {
                    return undefined;
                }
                const data = {};
                this.printTableResults.forEach((feature) => {
                    if (!data[feature.title]) {
                        const headers = [];
                        feature.columns
                            .filter(({ print }) => print)
                            .forEach((column) => {
                                headers.push(column);
                            });
                        if (headers.length) {
                            // Customize the table columns headings
                            const fields = headers.map(({ attribute, alias }) => ({
                                key: attribute,
                                label: alias ?? attribute
                            }));
                            data[feature.title] = {
                                title: feature.title,
                                headers,
                                data: [],
                                fields
                            };
                        }
                    }
                    if (data[feature.title]) {
                        const featureTableData = {};
                        data[feature.title].headers.forEach(({ attribute }) => {
                            featureTableData[attribute] =
                                feature.values_[attribute];
                        });
                        data[feature.title].data.push(featureTableData);
                    }
                });
                return data;
            },

            $_getSeperatedFeatureDataMobileNew() {
                const data = {};
                getGroups(
                    this.getSelectionData,
                    this.$store.getters.isMobile,
                    false,
                    this.$store.getters.getLocale
                )
                    .filter((group) => group.printable === true)
                    .forEach((group) => {
                        const headers = [];
                        group.informationAttributes
                            .filter(({ print }) => print)
                            .forEach((column) => {
                                headers.push(column);
                            });

                        if (headers.length) {
                            const fields = headers.map(({ attribute, alias }) => ({
                                key: attribute,
                                label: alias ?? attribute
                            }));
                            data[group.title] = {
                                title: group.title,
                                headers,
                                data: [],
                                fields
                            };

                            const featureTableData = {};
                            group.objects.forEach((object) => {
                                data[group.title].headers.forEach(
                                    ({ attribute }) => {
                                        featureTableData[attribute] =
                                            object.info[attribute].displayValue;
                                    }
                                );
                                data[group.title].data.push(featureTableData);
                            });
                        }
                    });
                return data;
            }
        }
    };
</script>

<style scoped lang="scss">
.feature-table {
    padding: 1em;
    min-height: 100%;
}
@media print {
    .feature-tables {
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .feature-table {
        min-height: auto;
        display: flex;
        flex-direction: column;
    }
}
</style>
